import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import type { PerformanceReport } from './data/api';
import { count } from './data/format';

interface ReportHeaderProps {
  report: PerformanceReport;
}

export function ReportHeader({ report }: ReportHeaderProps): ReactNode {
  const { periods, overview, kpi } = report;
  const scopeParts = [
    `${overview.accounts.length || 'all'} accounts`,
    overview.networks.join(', '),
    `leading KPI ${kpi.label}`,
  ].filter((part) => part.length > 0);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography component="h1" sx={{ fontSize: 22, fontWeight: 600, color: 'text.primary' }}>
        Performance Review {periods.current.label}
      </Typography>
      <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
        {scopeParts.join(' · ')} · compared against the previous period ({periods.priorPeriod.label}
        ) and last year ({periods.priorYear.label}).
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
        <Chip size="small" label={`${count(periods.current.activeCreatives)} active creatives`} />
        {periods.inFlight && (
          <Chip
            size="small"
            color="warning"
            label="Range runs past settled data — windows cut to the settled span"
          />
        )}
      </Box>
    </Box>
  );
}
